import { API } from "@/lib/api";

const UNTRACKED = ["/analytics", "/admin", "/portfolio-pdf", "/cover-letter"];
const UNTRACKED_SUFFIX = "/print";

function getId(storage, key, prefix) {
  let id = storage.getItem(key);
  if (!id) {
    id = `${prefix}-${Math.random().toString(36).slice(2)}-${Date.now().toString(36)}`;
    storage.setItem(key, id);
  }
  return id;
}

export function isTrackedPath(path) {
  return !UNTRACKED.some((p) => path.startsWith(p)) && !path.endsWith(UNTRACKED_SUFFIX);
}

const recent = new Map();

export function track(type, meta = {}, path = window.location.pathname) {
  if (!isTrackedPath(path)) return;
  const key = `${type}|${path}|${JSON.stringify(meta)}`;
  const now = Date.now();
  if (recent.get(key) > now - 1500) return;
  recent.set(key, now);
  const body = JSON.stringify({
    type,
    path,
    visitor_id: getId(localStorage, "sn_visitor", "v"),
    session_id: getId(sessionStorage, "sn_session", "s"),
    meta,
  });
  fetch(`${API}/analytics/event`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body,
    keepalive: true,
  }).catch(() => {});
}

export function trackSectionOnce(section) {
  const key = `sn_sec_${section}`;
  if (sessionStorage.getItem(key)) return;
  sessionStorage.setItem(key, "1");
  track("section_view", { section });
}

export async function fetchSummary() {
  const res = await fetch(`${API}/analytics/summary`);
  if (!res.ok) throw new Error("Failed to load analytics");
  return res.json();
}

export function getVisitorId() {
  return getId(localStorage, "sn_visitor", "v");
}

export async function fetchMoods() {
  const res = await fetch(`${API}/journey/moods`);
  if (!res.ok) throw new Error("Failed to load moods");
  return res.json();
}

export async function voteMood(stage, mood) {
  const res = await fetch(`${API}/journey/vote`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ stage, mood, visitor_id: getVisitorId() }),
  });
  if (!res.ok) throw new Error("Vote failed");
  return res.json();
}
